import { useCallback } from "react";

import { useNavigate } from "@/lib/router";
import { CHECKOUT_EVENTS } from "../events.checkout";
import { CheckoutService } from "../service.checkout";

interface UseCheckoutGoBackOptions {
  cartItemCount: number;
}

/**
 * Back navigation with analytics tracking.
 */
export function useCheckoutGoBack({ cartItemCount }: UseCheckoutGoBackOptions) {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    const { backRedirect, checkoutType } = CheckoutService;

    const defaultPath = checkoutType === "plan_purchase" ? "/pricing" : "/";
    navigate(backRedirect ? `/${backRedirect}` : defaultPath);

    CheckoutService.track(CHECKOUT_EVENTS.BACK_NAVIGATION, {
      types: ["posthog", "customerio"],
      properties: {
        checkout_type: checkoutType,
        back_to: backRedirect || "home",
        cart_item_count: cartItemCount,
      },
    });
  }, [navigate, cartItemCount]);

  return { handleGoBack };
}
